var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["items"], _excluded2 = ["label"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
import React from "react";
import { Row, Col } from "@riseart/antd-provider";
import { Button } from "@riseart/common";
import { CloseIcon } from "@riseart/icons";
import { Wrapper } from "../../sections/Wrapper";
import { MenuList } from "../list/List";
import { menuSubmenuWrapperCls, menuSubmenuWrapperInnerCls, menuSubmenuBackgroundCls, menuSubmenuMenuCls, menuSingleSubmenuCls, menuSubmenuCloseCls } from "./Menu.less";
function renderLabel(label) {
  var title = label;
  var menuLabel = label;
  var menuLabelAdditional = null;
  if (Array.isArray(label) && label.length > 1) {
    title = label.join(" ");
    menuLabel = _toConsumableArray(label);
    menuLabelAdditional = menuLabel.pop();
  }
  return {
    title,
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, menuLabel, menuLabelAdditional ? /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("span", null, menuLabelAdditional)) : null)
  };
}
__name(renderLabel, "renderLabel");
function MenuHorizontalSubmenu(_ref) {
  var _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, children = _ref.children, position = _ref.position, _ref$clickable = _ref.clickable, clickable = _ref$clickable === void 0 ? false : _ref$clickable, onClose = _ref.onClose, opened = _ref.opened;
  var totalItems = Array.isArray(items) && items.length || 0;
  var hasItems = totalItems > 0;
  var isMultiCol = totalItems > 1 && items[0].items;
  var closeButton = clickable ? /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    icon: /* @__PURE__ */ React.createElement(CloseIcon, null),
    onClick: onClose,
    className: menuSubmenuCloseCls
  }) : null;
  var colSpans = {
    sm: totalItems > 3 && 8 || totalItems <= 3 && totalItems >= 2 && 8 || 8,
    lg: totalItems === 4 && 5 || totalItems <= 3 && totalItems >= 2 && 6 || totalItems === 2 && 8 || 4
  };
  if (children) {
    return /* @__PURE__ */ React.createElement("div", {
      className: menuSubmenuWrapperCls
    }, /* @__PURE__ */ React.createElement(Wrapper, {
      className: menuSubmenuWrapperInnerCls,
      sizes: "wide"
    }, closeButton, children));
  }
  return hasItems && isMultiCol && /* @__PURE__ */ React.createElement("div", {
    className: menuSubmenuWrapperCls
  }, /* @__PURE__ */ React.createElement(Wrapper, {
    className: menuSubmenuWrapperInnerCls,
    sizes: {
      xs: "wide",
      sm: "wide",
      md: "wide",
      lg: "narrow",
      xl: "narrow"
    }
  }, closeButton, /* @__PURE__ */ React.createElement(Row, {
    align: "top",
    justify: position || (totalItems <= 3 ? "center" : "space-around"),
    gutter: 32
  }, items && items.length ? items.map(function(_ref2, index) {
    var columnItems = _ref2.items, linkProps = _objectWithoutProperties(_ref2, _excluded);
    return /* @__PURE__ */ React.createElement(Col, {
      sm: colSpans.sm,
      lg: colSpans.lg,
      key: index
    }, /* @__PURE__ */ React.createElement(MenuList, {
      opened,
      titleProps: linkProps,
      onClose,
      items: columnItems && columnItems.map(function(_ref3) {
        var label = _ref3.label, rest = _objectWithoutProperties(_ref3, _excluded2);
        return _objectSpread(_objectSpread({}, rest), renderLabel(label));
      }) || []
    }));
  }) : null))) || hasItems && !isMultiCol && /* @__PURE__ */ React.createElement("div", {
    className: menuSubmenuMenuCls
  }, /* @__PURE__ */ React.createElement(MenuList, {
    className: menuSingleSubmenuCls,
    border: true,
    items,
    onClose,
    opened
  }), /* @__PURE__ */ React.createElement("div", {
    className: menuSubmenuBackgroundCls
  })) || null;
}
__name(MenuHorizontalSubmenu, "MenuHorizontalSubmenu");
export {
  MenuHorizontalSubmenu
};
